@if (dataVisible$ | async) {
  <form [formGroup]="totalenFG">
    <div>
      <div class="row">
        <div class="col col-1 pt-3">
          <p>Zorgtoeslag</p>
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control [showAllDecimals]="false"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="zorg3"
                                            label="Recht op toeslag"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control [showAllDecimals]="false"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="zorg2"
                                            label="Ontvangen voorschot"
                                            prefix="€ -"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          @if(zorg <= 0) {
            <snelstart-ui-number-form-control [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="zorg1"
                                              label="Resteert"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          } @else {
            <snelstart-ui-number-form-control [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="zorg1"
                                              label="Resteert"
                                              prefix="€ -"
            >
            </snelstart-ui-number-form-control>
          }
        </div>
        <div class="col-4"></div>
      </div>
    </div>
    <div>
      <div class="row">
        <div class="col col-1">
          <p>Kindgebonden budget</p>
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control [showAllDecimals]="false"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="kgb3"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control [showAllDecimals]="false"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="kgb2"
                                            prefix="€ -"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          @if (kgb <= 0) {
            <snelstart-ui-number-form-control [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="kgb1"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          } @else {
            <snelstart-ui-number-form-control [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="kgb1"
                                              prefix="€ -"
            >
            </snelstart-ui-number-form-control>
          }
        </div>
        <div class="col-4"></div>
      </div>
    </div>
    <div>
      <div class="row">
        <div class="col col-1">
          <p>Kinderopvangtoeslag</p>
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control [showAllDecimals]="false"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="kot3"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control [showAllDecimals]="false"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="kot2"
                                            prefix="€ -"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          @if(kot <= 0) {
            <snelstart-ui-number-form-control [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="kot1"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          } @else {
            <snelstart-ui-number-form-control [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="kot1"
                                              prefix="€ -"
            >
            </snelstart-ui-number-form-control>
          }
        </div>
        <div class="col-4"></div>
      </div>
    </div>
    <div>
      <div class="row">
        <div class="col col-1">
          <p>Huurtoeslag</p>
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control [showAllDecimals]="false"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="huur3"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control [showAllDecimals]="false"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="huur2"
                                            prefix="€ -"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          @if(huur <= 0) {
            <snelstart-ui-number-form-control [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="huur1"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          } @else {
            <snelstart-ui-number-form-control [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="huur1"
                                              prefix="€ -"
            >
            </snelstart-ui-number-form-control>
          }
        </div>
        <div class="col-4"></div>
      </div>
    </div>
  </form>
  <form [formGroup]="totalenFG">
    <div>
      <div class="row">
        <div class="col col-1">
          @if(saldo <= 0) {
            <b>Te ontvangen</b>
          } @else {
            <b>Te betalen</b>
          }
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control [showAllDecimals]="false"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="sumToeslagen"

                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control [showAllDecimals]="false"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="sumVoorschot"
                                            prefix="€ -"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          @if(saldo <= 0) {
            <snelstart-ui-number-form-control [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="sumSaldo"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          } @else {
            <snelstart-ui-number-form-control [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="sumSaldo"
                                              prefix="€ -"
            >
            </snelstart-ui-number-form-control>
          }
        </div>
        <div class="col-4"></div>
      </div>
    </div>
  </form>
}@else {
  <snelstart-ui-spinner size="medium"></snelstart-ui-spinner>
}
